module.exports = __webpack_public_path__ + "static/home1-486d52a342b2a89c0c71c913ec44ac28.jpg";